import { ref } from 'vue';
import { getPortalNav } from '@/api/common';
import { getNewIndexNavSeed, parsePortalNav } from '@/utils/newIndexNav.js';

const navTree = ref(null);
let loadingPromise = null;

export function usePortalNav() {
  async function ensureNav() {
    if (navTree.value) return navTree.value;
    if (loadingPromise) return loadingPromise;

    loadingPromise = getPortalNav()
      .then((res) => {
        const tree = parsePortalNav(res);
        navTree.value = tree || getNewIndexNavSeed();
        return navTree.value;
      })
      .catch(() => {
        navTree.value = getNewIndexNavSeed();
        return navTree.value;
      })
      .finally(() => {
        loadingPromise = null;
      });

    return loadingPromise;
  }

  return {
    navTree,
    ensureNav,
  };
}
